
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-41 164.9 512 512"}},[_c('path',{attrs:{"d":"M89.4 487.4H39V164.9h50.4v322.5zM189.9 241h-50.4v435.9h50.4V241zm100.6 0h-50.4v435.9h50.4V241zm100.5-.1h-50.4v247H391v-247z"}})])
      }
    
      }
    